import UserProfileIcon from './component'

export default UserProfileIcon
